import React, { useState, useEffect } from "react";
import { changePassword, errMsg } from "../../services/accountApi";
import { authCss, S, PasswordField, MIN_LEN } from "./authUi";

export default function ChangePasswordModal({ onClose, showToast }) {
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [conf, setConf] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const h = (e) => { if (e.key === "Escape" && !busy && onClose) onClose(); };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [busy, onClose]);

  const valid = cur && next.length >= MIN_LEN && next === conf;
  const hint = next.length < MIN_LEN ? `At least ${MIN_LEN} characters` : conf && next !== conf ? "Passwords do not match" : "";

  const submit = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (busy || !valid) return;
    setBusy(true); setError("");
    try {
      await changePassword(cur, next);
      if (showToast) showToast("Password changed", "success");
      if (onClose) onClose();
    } catch (err) {
      setError(errMsg(err));
      setBusy(false);
    }
  };

  return (
    <div className="img-modal-overlay" onMouseDown={(e) => { if (e.target === e.currentTarget && !busy && onClose) onClose(); }}>
      <style>{authCss}</style>
      <form className="img-modal-box" onSubmit={submit} noValidate
        style={{ width: "min(380px, calc(100vw - 24px))", alignItems: "stretch", padding: 20, gap: 0, boxSizing: "border-box", overflowY: "auto" }}>
        <h2 style={{ ...S.title, marginBottom: 14 }}>Change password</h2>
        <PasswordField id="cp-cur" label="Current password" value={cur} onChange={(v) => { setCur(v); setError(""); }}
          autoComplete="current-password" autoFocus disabled={busy} />
        <PasswordField id="cp-new" label="New password" value={next} onChange={(v) => { setNext(v); setError(""); }}
          autoComplete="new-password" disabled={busy} />
        <PasswordField id="cp-conf" label="Confirm new password" value={conf} onChange={(v) => { setConf(v); setError(""); }}
          autoComplete="new-password" disabled={busy} />
        <div style={{ fontSize: 12, color: "var(--text-muted)", margin: "0 0 12px", minHeight: 16 }}>{hint}</div>
        {error && <div role="alert" style={S.err}>{error}</div>}
        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
          <button type="button" className="auth-ghost" onClick={onClose} disabled={busy}>Cancel</button>
          <button type="submit" className="auth-btn" style={{ width: "auto", padding: "9px 18px" }} disabled={busy || !valid}>
            {busy ? "Saving…" : "Change password"}
          </button>
        </div>
      </form>
    </div>
  );
}
